import { SecEventCategory } from "../../../../domain/sec-event-category";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UI } from "../../../../services/ui.service";
import { SecEventsService } from "../sec-events.service";
import { SecEventType } from "../../../../domain/sec-events";

@Component({
  selector: "evrideo-calendar-expandable-new-sec-event",
  templateUrl: "./calendar-expandable-new-sec-event.component.html",
  styleUrls: ["./calendar-expandable-new-sec-event.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarExpandableNewSecEventComponent implements OnInit {
  @Input() showId;
  @ViewChild("newSecEventElement", { static: true })
  newSecEventElement: ElementRef;

  isHovering = false;
  secEventType = SecEventType;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private ui: UI,
    private secEventsService: SecEventsService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewChecked() {
    this.newSecEventElement.nativeElement.ondragover = (event: DragEvent) => {
      event.preventDefault();
    };
  }

  async onDrop(event: DragEvent) {
    this.isHovering = false;

    console.log("CalendarExpandableNewSecEventComponent->onDrop");
    return;
    const draggedMedia = event.dataTransfer.getData("text/media")
      ? JSON.parse(event.dataTransfer.getData("text/media"))
      : null;
    const draggedGraphic = event.dataTransfer.getData("text/graphics")
      ? JSON.parse(event.dataTransfer.getData("text/graphics"))
      : null;

    const draggedMarker = event.dataTransfer.getData("text/markers")
      ? JSON.parse(event.dataTransfer.getData("text/markers"))
      : null;

    if (!draggedMedia && !draggedGraphic && !draggedMarker) {
      return;
    }

    try {
      if (!!draggedMedia) {
        await this.secEventsService.createEvent(
          this.showId,
          SecEventCategory.FloatingMedia,
          draggedMedia.id,
        );
      } else if (!!draggedGraphic && !draggedGraphic.isTemplate) {
        await this.secEventsService.createEvent(
          this.showId,
          SecEventCategory.Graphics,
          draggedGraphic.name,
        );
      } else if (!!draggedMarker) {
        // @TODO
      }
    } catch (error) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "error creating new sec event",
        message: error.message,
      });
    } finally {
      // this._isLoading = false;
    }
  }

  onDragEnter() {
    this.isHovering = true;
    this.changeDetectorRef.markForCheck();
  }

  onDragLeave() {
    this.isHovering = false;
    this.changeDetectorRef.markForCheck();
  }

  onDragOver(event: DragEvent) {
    this.isHovering = true;

    if (
      event.dataTransfer.types.includes("text/media") ||
      event.dataTransfer.types.includes("text/show") ||
      event.dataTransfer.types.includes("text/graphics") ||
      event.dataTransfer.types.includes("text/markers")
    ) {
      event.preventDefault();
    }
  }
}
